export const getRoomName = (mediaDetails: any, uniqueSuffix?: string): string => {
	if (!mediaDetails) {
		return 'qbrick-meeting';
	}

	return `qbrick-meet-${uniqueSuffix ?? mediaDetails?.id ?? Date.now()}`;
};
